<template>
	<li class="partner-box">
		<a :href="item.link" :title="item.name" target="_blank">
			<img :src="item.image" :alt="item.name" />
		</a>
	</li>
</template>

<script>
export default {
	name: 'PartnersContainerBox',
	props: {
		item: {
			type: Object,
			required: true,
		},
	},
}
</script>



// WEBPACK FOOTER //
// src/components/sections/boxes/PartnersContainerBox.vue